import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const WishlistContext = createContext(null);
const KEY = "mt_wishlist_v1";

export function WishlistProvider({ children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) { /* noop */ }
  }, []);

  useEffect(() => {
    try { window.localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* noop */ }
  }, [items]);

  const isWishlisted = useCallback((id) => items.some((i) => i.id === id), [items]);

  const toggle = useCallback((product) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.id === product.id);
      if (exists) return prev.filter((i) => i.id !== product.id);
      return [...prev, {
        id: product.id,
        name: product.name,
        price: product.price,
        category: product.category,
        tag: product.tag,
        image_color: product.image_color,
      }];
    });
  }, []);

  const remove = useCallback((id) => setItems((prev) => prev.filter((i) => i.id !== id)), []);
  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => ({ items, isWishlisted, toggle, remove, clear, count: items.length }), [items, isWishlisted, toggle, remove, clear]);
  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
}

export function useWishlist() {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error("useWishlist must be used within WishlistProvider");
  return ctx;
}
